module.exports = __webpack_public_path__ + "img/horizontal_2_1_6005.673f1946.png";